import React, { useState } from "react";
import "./BookDemo.css";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export default function BookDemo({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    course: "",
    mode: "",
  });

  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submit (Firebase only)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    // ⏱ Safety timeout
    const timer = setTimeout(() => {
      setLoading(false);
      alert("⚠️ Submission timed out. Please try again.");
    }, 7000);

    try {
      /* 🔥 SAVE TO FIRESTORE */
      await addDoc(collection(db, "demoBookings"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      clearTimeout(timer);

      alert("✅ Demo session booked successfully!");

      setFormData({
        name: "",
        phone: "",
        email: "",
        course: "",
        mode: "",
      });

      if (onClose) onClose();
    } catch (error) {
      clearTimeout(timer);
      console.error("Submission error:", error);
      alert("❌ Failed to submit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bookdemo-overlay">
      <div className="bookdemo-modal">
        {onClose && (
          <button className="bookdemo-close" onClick={onClose}>
            ×
          </button>
        )}

        <div className="bookdemo-header">
          <h2>Book a Free Demo Session</h2>
          <p>Get expert guidance and a personalized demo.</p>
        </div>

        <form className="bookdemo-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter mobile number"
              required
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              required
            />
          </div>

          <div className="form-group">
            <label>Course Interested In</label>
            <select
              name="course"
              value={formData.course}
              onChange={handleChange}
              required
            >
              <option value="">Select a course</option>
              <option>School Students</option>
              <option>College Students</option>
              <option>Internships & Projects</option>
              <option>Communications</option>
              <option>Faculty Development Program</option>
              <option>Banking Aspirants</option>
              <option>Home Makers</option>
            </select>
          </div>

          <div className="form-group">
            <label>Preferred Mode</label>
            <select
              name="mode"
              value={formData.mode}
              onChange={handleChange}
              required
            >
              <option value="">Select mode</option>
              <option>ONLINE</option>
              <option>OFFLINE</option>
              <option>HYBRID</option>
            </select>
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Booking…" : "Book Demo Session"}
          </button>

          <p className="form-note">
            Our team will contact you shortly.
          </p>
        </form>
      </div>
    </div>
  );
}